
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/range",
      function () {
        return require("private-next-pages/about/range/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/range"])
      });
    }
  